import { render, staticRenderFns } from "./verifyResetPasswordToken.vue?vue&type=template&id=4d9ac4b1&"
import script from "./verifyResetPasswordToken.vue?vue&type=script&lang=js&"
export * from "./verifyResetPasswordToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports